export default {
  meta: {
    title: '岗位管理'
  }
};
